import BusinessPagePublic from "./BusinessPagePublic";
import UserProfile from "../SearchHome/UserProfile";
import { useSelector } from "react-redux";

const CombinedBusinessPage = () => {
    const { UserProfileID } = useSelector((state) => state.app);
    return (
        <div className="combined-business-page">
            {UserProfileID ? <UserProfile /> : <BusinessPagePublic />}
        </div>
    );
}

export default CombinedBusinessPage;
